import React from "react";
import { AxiosError } from "axios";
import AccessDeniedPedidos from "./AccessDeniedPedidos";

interface PermissionCheckProps {
  error: Error | null;
  children: React.ReactNode;
}

const PermissionCheck: React.FC<PermissionCheckProps> = ({
  error,
  children,
}) => {
  // Verificar se houve erro de permissão (403)
  if (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 403) {
      return <AccessDeniedPedidos />;
    }
  }

  return <>{children}</>;
};

export default PermissionCheck;
